import React, { useEffect, useState } from "react";
import SliderAuth from "../../../components/SliderAuth/SliderAuth";
import { images } from "../../../config/images";
import {
    Grid,
    FormControl,
    OutlinedInput,
    InputAdornment,
} from "@mui/material";
import { Button } from "../../../components/Button/button"
import { useNavigate, Link } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { toast } from "react-toastify";
import translations from "../../../config/language";
import { forgotPassword } from "../../../config/services";
import { auth, signInWithPhoneNumber, setUpRecaptcha  } from "../../../config/firebase";



const ForgotPasswordForm = ({setMobileNo, onNextClick}) => {

    const navigate = useNavigate();

    const notify = (message) => {
        toast.error(message, {
            theme: "colored",
            position: toast.POSITION_TOP_RIGHT,
            toastClassName: "custom-toast",
        });
    };

    const notifySuccess = (message) => {
        toast.success(message, {
            theme: "colored",
            position: toast.POSITION_TOP_RIGHT,
            toastClassName: "custom-toast",
        });
    };

    
    const [formvalues, setFormvalue] = useState({
        mobileNumber: "",
    });
    const [loading, setIsLoading] = useState(false);
    const [verificationId, setVerificationId] = useState(null);
    const [otpSent, setOtpSent] = useState(false);

    const handleChange = (e) => {
        setFormvalue({ ...formvalues, [e.target.name]: e.target.value });
    };

    const sendOtp = async (phoneNumber) => {
        if (!phoneNumber) {
            toast.error("Please enter a mobile number.");
            return;
        }

        const formattedPhoneNumber = `+91 ${phoneNumber}`;
     
        try {
            setIsLoading(true)
      // ✅ Ensure reCAPTCHA is initialized
      setUpRecaptcha();
            // ✅ Send OTP
            const confirmationResult = await signInWithPhoneNumber(auth, formattedPhoneNumber, window.recaptchaVerifier);
            window.confirmationResult = confirmationResult;
            notifySuccess("OTP Sent Successfully!");
            setMobileNo(phoneNumber);
            onNextClick("verifyOtp"); // ✅ Navigate to OTP Verification Screen
            setIsLoading("false");
        }  catch (error) {
            console.log("error", error)
            notify(error.message);
            setIsLoading(false);
        }
    };
    
    const handleSubmit = async () => {
        if (!formvalues.mobileNumber) {
            notify("Please enter your Mobile Number.");
            return true;
        }
        const mobileRegex = /^[6-9]\d{9}$/;
        if (!mobileRegex.test(formvalues.mobileNumber)) {
            notify("Please enter a valid Mobile Number.");
            return true;
        }
        const params = {
            mobile_number: `91${formvalues.mobileNumber}`
        }
        sendOtp(formvalues.mobileNumber); // ✅ Send OTP via Firebase

    };


    const language = process.env.REACT_APP_LANGUAGE;

    return (
        <>
            <div></div>
            <Grid container className="main-container">
                <SliderAuth />
                <Grid item xs={12} md={5} lg={4} className="signIn-form-wrap">
                    <div className="logo-div">
                        <Link to="#" onClick={(e) => { e.preventDefault(); navigate(-1); }}
                            className="page-back-btn"> {/* navigate to back screen */}
                            <ArrowBackIcon className="back-arrow-icon" />
                        </Link>
                        <div className="pb-2">
                            <img src={images.forgotPasswordLogo} alt="Sign Up" className="signIn-logo" />
                        </div>
                    </div>
                    <h3 className="text-center singIn-title">{translations[language].forgotPassword}</h3>

                    {/* Sing up Form  */}

                    <div className="signUp-form">
                        <div className="forgot-password-div">
                            {translations[language].enterYourNumberToRecieveACode}
                        </div>
                        <FormControl fullWidth sx={{ m: 1 }}>
                            <OutlinedInput
                                value={formvalues.mobileNumber}
                                onChange={handleChange}
                                name="mobileNumber"
                                onKeyPress={(e) => {
                                    if (!/[0-9]/.test(e.key)) {
                                        e.preventDefault()
                                    }
                                }}
                                inputProps={{ maxLength: 10, pattern: "[0-9]*", inputMode: "numeric" }}
                                startAdornment={
                                    <InputAdornment position="start">
                                        <img src={images.mobileIcon} alt="mobile-icon" className="input-logo" />
                                    </InputAdornment>}
                                placeholder={translations[language].mobileNumber}
                            />
                        </FormControl>

                        <div id="recaptcha-container"></div>

                    </div>
                    <div style={{ marginTop: "2rem", width: "100%", padding: "20px 0" }}>
                        <Button
                            title={translations[language].getOtp}
                            classname={"custom-button"}
                            onClick={handleSubmit}
                            loading={loading}
                        />
                    </div>
                </Grid>
            </Grid>
        </>
    )
}
export default ForgotPasswordForm;